import {ICalculateEstimateItem} from 'src/app/types/payment.type';

export enum SORT_TYPE {
  ALPHABET = 'ALPHABET',
  ALPHABET_A = 'ALPHABET_A',
  ALPHABET_Z = 'ALPHABET_Z',
  TRAFFIC = 'TRAFFIC',
  TRAFFIC_LOW = 'TRAFFIC_LOW',
  TRAFFIC_HIGH = 'TRAFFIC_HIGH',
  PRICE = 'PRICE',
  PRICE_LOW = 'PRICE_LOW',
  PRICE_HIGH = 'PRICE_HIGH',
}

export function getTier(value: number) {
  if (value <= 100000) {
    return 'Small';
  } else if (value <= 1000000) {
    return 'Medium';
  } else {
    return 'Large';
  }
}

export function getTierIdForSiteSize(siteSize: string): string {
  switch (siteSize) {
    case 'Small':
      return 'step_1';
    case 'Medium':
      return 'step_2';
    case 'Large':
      return 'step_3';
    default:
      throw new Error(`Invalid site size: ${siteSize}`);
  }
}

export function sort(sortType: SORT_TYPE): void {
  switch (sortType) {
    case SORT_TYPE.ALPHABET:
      this.selectedSortType = !this.selectedSortType
        ? SORT_TYPE.ALPHABET_A
        : this.selectedSortType === SORT_TYPE.ALPHABET_A
          ? SORT_TYPE.ALPHABET_Z
          : SORT_TYPE.ALPHABET_A;
      break;
    case SORT_TYPE.TRAFFIC:
      this.selectedSortType = !this.selectedSortType
        ? SORT_TYPE.TRAFFIC_HIGH
        : this.selectedSortType === SORT_TYPE.TRAFFIC_HIGH
          ? SORT_TYPE.TRAFFIC_LOW
          : SORT_TYPE.TRAFFIC_HIGH;
      break;
    case SORT_TYPE.PRICE:
      this.selectedSortType = !this.selectedSortType
        ? SORT_TYPE.PRICE_HIGH
        : this.selectedSortType === SORT_TYPE.PRICE_HIGH
          ? SORT_TYPE.PRICE_LOW
          : SORT_TYPE.PRICE_HIGH;
      break;
  }
}

export function getSites(data: {sites: ICalculateEstimateItem; selectedSort: SORT_TYPE}) {
  const [sites, selectedSort] = [data[0], data[1]];
  if (!sites) {
    return [];
  }
  switch (selectedSort) {
    case SORT_TYPE.ALPHABET_A:
      return sites.slice().sort((a, b) => {
        return a.siteItem.host.localeCompare(b.siteItem.host);
      });
    case SORT_TYPE.ALPHABET_Z:
      return sites.slice().sort((a, b) => {
        return b.siteItem.host.localeCompare(a.siteItem.host);
      });
    case SORT_TYPE.TRAFFIC_HIGH:
      return sites.slice().sort((a, b) => b.siteItem.views - a.siteItem.views);
    case SORT_TYPE.TRAFFIC_LOW:
      return sites.slice().sort((a, b) => a.siteItem.views - b.siteItem.views);
    case SORT_TYPE.PRICE_HIGH:
      return sites.slice().sort((a, b) => b.cost - a.cost);
    case SORT_TYPE.PRICE_LOW:
      return sites.slice().sort((a, b) => a.cost - b.cost);
    default:
      return sites;
  }
}
